import { IAuth } from "interfaces/auth";

interface IAuthError {
  email: string;
  password: string;
  socialMedia: string;
}

type IMessenger = "telegram" | "whatsapp" | "viber";

//  token
export const saveToken = (token: string): void => {
  return localStorage.setItem("authToken", token || "");
};

// validate form
export const validateForm = (data: IAuth, messenger?: IMessenger) => {
  const errors: IAuthError = {
    email: "",
    password: "",
    socialMedia: "",
  };

  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email)) {
    errors.email = "Enter the correct email address";
  }

  if (data.password.length < 6) {
    errors.password = "The password must contain at least 6 characters";
  }

  if (!data.telegram && !data.whatsapp && !data.viber && !data.phone) {
    errors.socialMedia = "The contact field cannot be empty";
  }

  if (data.telegram && messenger === "telegram" && !/^@[A-Za-z0-9_]{5,32}$/.test(data.telegram)) {
    errors.socialMedia = "Enter a valid Telegram username. For example: @ducksaypwa.";
  }

  if (data.whatsapp && messenger === "whatsapp" && !/^\+[1-9]\d{9,14}$/.test(data.whatsapp)) {
    errors.socialMedia = "Enter a valid phone number in international format. For example: +380661234567";
  }

  return errors;
};

export const getCountryFlags = (geoArray: string[], countries: any) => {
  return geoArray.map((geoCode) => {
    const country = countries?.find((c: any) => geoCode.includes(c.code));
    return country ? country.flag : null;
  });
};
